export default "__VITE_ASSET__9b52b464__"